import { useRef } from 'react';
import { enUS as en, ru } from 'date-fns/locale';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { DateTimePickerProps, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { withControl } from '@features/effector-form/hoc/withControl';
import { getSafePickerLocale } from '@shared/utils/getSafePickerLocale';
import * as Styled from './styled';

const EN = 'en';
const LNG = localStorage.getItem('lang') || EN;

export const DateTimePickerControl = withControl<DateTimePickerProps<any>>(
  ({ value, setValue, error, label, required, readOnly, disabled, disablePast }) => {
    const inputRef = useRef(null);

    const showError = !readOnly && !!error;

    return (
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={LNG === EN ? en : ru}
        localeText={getSafePickerLocale(LNG)}
      >
        <FormControl required={required} disabled={disabled} error={showError}>
          <FormLabel>{label}</FormLabel>

          <Styled.DateTimePicker
            value={value}
            onChange={(newValue) => setValue(newValue)}
            inputRef={inputRef}
            slotProps={{
              field: { clearable: true },
              textField: {
                error: showError,
                size: 'small',
              },
            }}
            readOnly={readOnly}
            disabled={disabled}
            disablePast={disablePast}
            ampm={LNG === EN ? true : undefined}
          />
          <FormHelperText error>{error}</FormHelperText>
        </FormControl>
      </LocalizationProvider>
    );
  }
);
